export var WCIOptions = {
    Grid: [{
        height: "100%",
    }],
    Legend: {
        data: ["WCI广告", "WCI外链", "WCI直播", "WCI公众号", "WCI搜一搜", "WCI问一问", "WCI视频号"],
        bottom: "5%",
        left: "center",
    },
}

export var WCITKOptions = {
    Grid: [{
        top: 0,
        height: "50%",
    },
    {
        top: "50%",
        height: "50%",
    }],
    Legend: [{
        data: ["WCI广告", "WCI外链", "WCI直播", "WCI公众号", "WCI搜一搜", "WCI问一问", "WCI视频号"],
        top: "48%",
        left: "center",
    }, {
        data: ["TK搜索", "TK综合"],
        bottom: 0,
        left: "center",
        gridindex: 1,
    }],
}
